import script from "./PlanFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanFeature.vue?vue&type=script&setup=true&lang=js"

import "./PlanFeature.vue?vue&type=style&index=0&id=82ba54fa&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82ba54fa"]])

export default __exports__